import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export const SupportedByFooter: React.FC = () => {
  const { t: translate } = useTranslation("lists");

  return (
    <Box
      sx={{
        mt: 2,
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        gap: 1,
        width: "100%",
      }}
    >
      <Typography variant="caption" color="grey.900">
        {translate("forms.preview.supported_by")}
      </Typography>
      <img height={16} src="/images/nexl_logo.svg" alt="go to home" />
    </Box>
  );
};
